var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._l((_vm.parts),function(part,index){return _c('span',{key:index},[_vm._v("\n        "+_vm._s(part)+"\n        "),(index < _vm.parts.length - 1)?_c('a',{staticClass:"require-login-link",attrs:{"href":_vm.link}},[_vm._v(" logged in ")]):_vm._e()])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }